import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import DownloadGroupSummaryCSVButton from "../../../report/export/DownloadGroupSummaryCSVButton";
import {getAdminInvoiceGroupSummaryReportUrl, getAdminInvoiceReportUrl} from "../../../../requests/reports/invoices/admin-invoice-requests";
import {getAdminInvoiceGroupSummaryOptions} from "../../../../requests/type-requests";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../../../util/NetworkErrorUtil";
import DownloadCSVButton from "../../../report/export/DownloadCSVButton";
import type {AdminInvoicesQueryType} from "./AdminInvoicesQueryType";
import {useSnackbar} from "../../../../context/snackbar-context";
import {LabelValue} from "../../../../types/common/LabelValue";

interface ExportCSVsProps {
  query: AdminInvoicesQueryType;
}

/**
 * Renders the standard CSV download button and the group summary CSV download button for the admin invoice report.
 *
 * @param query The query parameters used in the API request that generates the report.
 */
const ExportCSVs = ({query}: ExportCSVsProps) => {
  const [groupSummaryOptions, setGroupSummaryOptions] = useState<LabelValue[]>([]);
  const { snackbarShowMessage } = useSnackbar();

  useEffect(() => {
    getAdminInvoiceGroupSummaryOptions().then((response) => {
      setGroupSummaryOptions(response.body);
    }).catch((error) => {
      snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error');
    });
  }, [snackbarShowMessage]);

  return (
    <Grid item container justifyContent={'end'} gap={2}>
      <Grid item>
        <DownloadCSVButton title={'Download Report'} reportUrl={getAdminInvoiceReportUrl(query)} />
      </Grid>
      <DownloadGroupSummaryCSVButton
        queryParams={query}
        groupByOptions={groupSummaryOptions}
        getUrl={getAdminInvoiceGroupSummaryReportUrl}
      />
    </Grid>
  );
};

export default ExportCSVs;
